import { useEffect, useState } from "react";
import { Modal, Button, Select } from "antd";
import { useSelector } from "react-redux";
import "./index.scss";

interface CopyVisitMappingModalProps {
  visible: boolean;
  doCancel: () => void;
  doConfirm: () => void;
  selectedVisitsOnMapping: (
    obj: Digital_Protocol_SoA_Table_Data.Entity[]
  ) => void;
  selectedPeriodsOnMapping: (
    obj: Digital_Protocol_SoA_Table_Data.PeriodData[]
  ) => void
}

export function CopyVisitMappingModal({
  visible,
  doCancel,
  doConfirm,
  selectedVisitsOnMapping,
}: CopyVisitMappingModalProps) {
  const dpSoaState = useSelector((state: any) => state?.dpSoaReducer);
  const [allActivities, setAllActivities] = useState<
    Digital_Protocol_SoA_Table_Data.Entity[]
  >([]);
  const [periodData, setPeriodData] = useState<
  Digital_Protocol_SoA_Table_Data.PeriodData[]
>([]);
  const [selectedValues, setSelectedValues] = useState<
    Digital_Protocol_SoA_Table_Data.Entity[]
  >([]);

  useEffect(() => {
    const labs = dpSoaState?.soaAddedLabs;
    const procedures = dpSoaState?.soaAddedProcedures;
    const questionnaires = dpSoaState?.soaAddedQuestionnaires;
    const studyProcedures = dpSoaState?.soaAddedStudyProcedures;
    const examination = dpSoaState?.soaAddedExamination;
    const activities = [
      ...labs,
      ...procedures,
      ...questionnaires,
      ...studyProcedures,
      ...examination,
    ];
    setPeriodData(dpSoaState?.soaPeriod_data);
    setAllActivities(activities);
  }, [dpSoaState]);

  const handleSubmit = async () => {
    doConfirm();
  };

  const handleChange = (selectedValues) => {
    const selectedActivityObjects = allActivities.filter((activity) =>
      selectedValues.includes(activity["Standard Activity"])
    );
    selectedVisitsOnMapping(selectedActivityObjects);
    setSelectedValues(selectedValues);
  };

  const copyActivityHandler = () => {
    resetSelection();
    handleSubmit();
  };

  const resetSelection = () => {
    setSelectedValues([]);
  };

  const handleCancel = () => {
    resetSelection();
    doCancel();
  };

  const content = (
    <div>
      <p className="activityLabel">
        Select the activities you would like to follow this visit map:
      </p>
      <Select
        mode="multiple"
        showArrow
        style={{ width: "100%" }}
        onChange={handleChange}
        value={selectedValues}
        placeholder="Select Activity"
        options={allActivities.map((name, index) => ({
          value: name["Standard Activity"],
          label: name["Standard Activity"],
        }))}
      />
      <label>
        Note: The frequency values associated with the selected activity will be
        copied with the visit mappings. Footnotes will not be copied.
      </label>
      <br />
    </div>
  );

  return (
    <Modal
      visible={visible}
      title={"Copy Activity Visit Mapping"}
      className="copyActivityModal"
      onCancel={handleCancel}
      footer={[
        <Button key="back" onClick={handleCancel}>
          Cancel
        </Button>,
        <Button
          key="submit"
          style={{
            backgroundColor: "#ca4a04",
            color: "#fff",
            borderColor: "#ca4a04",
          }}
          onClick={copyActivityHandler}
        >
          {'Copy Activity'}
        </Button>,
      ]}
    >
       {content}
    </Modal>
  );
}
export default CopyVisitMappingModal;
